import { render } from "./DaoYouBuZhu.vue?vue&type=template&id=4fa079c4&scoped=true"
import script from "./DaoYouBuZhu.vue?vue&type=script&lang=js"
export * from "./DaoYouBuZhu.vue?vue&type=script&lang=js"

import "./DaoYouBuZhu.vue?vue&type=style&index=0&id=4fa079c4&lang=less&scoped=true"

import exportComponent from "D:\\fxwl\\wx-wl_full\\wx-wl_full\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fa079c4"]])

export default __exports__